import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ToastType {
  Success = 'success',
  Failure = 'failure',
  Warning = 'warning',
  Default = 'default'
}

export interface ToastState {
  activeToast: {
    type: ToastType;
    message: string;
    timestamp: number;
  } | null;
}

const initialState: ToastState = {
  activeToast: null
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<{ type: ToastType; message: string }>) => {
      const { type, message } = action.payload;
      state.activeToast = {
        type,
        message,
        timestamp: Date.now()
      };
    },
    clearActiveToast: (state) => {
      state.activeToast = null;
    }
  }
});

export const { showToast, clearActiveToast } = toastSlice.actions;
export default toastSlice.reducer;